<breadcrumb [paginas]="[
  {route:'/home',name:'Home'},
  {route:'/consolidado',name:'Relatórios'},
  {route:'/relatorio/diagnostico-aprovacao-revertida',name:'Diagnóstico de Aprovação'}
]" />

<section class="section-saudacao">
  <div class="container">
    <h2 class="titulo-page">Diagnóstico de Aprovação</h2>
    <p class="descricao-page">
      Compara o status atual das atividades com o histórico de avaliação.
      Pesquise para visualizar os candidatos e, se confirmado, aplique a correção.
    </p>
  </div>
</section>

<section class="section-filtro">
  <div class="container">
    <form [formGroup]="form" class="filtros-linha">
      <div class="grupo-filter">
        <p><b>Polo</b></p>
        <ng-select
          [items]="polos"
          bindLabel="descricaoPolo"
          bindValue="codigoPolo"
          placeholder="Selecione um Polo"
          formControlName="codigoPolo"
          (change)="OnChangePolo()">
        </ng-select>
      </div>

      <div class="grupo-filter">
        <p><b>URE</b></p>
        <ng-select
          [items]="diretorias"
          bindLabel="nomeDiretoria"
          bindValue="codigoDiretoria"
          placeholder="Selecione uma URE"
          formControlName="codigoDiretoria">
        </ng-select>
      </div>

      <div class="grupo-filter">
        <p><b>Data início</b></p>
        <input type="date" class="input-date" formControlName="dataInicio" />
      </div>

      <div class="grupo-filter">
        <p><b>Data fim</b></p>
        <input type="date" class="input-date" formControlName="dataFim" />
      </div>

      <div class="grupo-acoes">
        <button type="button" class="btn_primary" (click)="pesquisar()">Pesquisar</button>
        @if (isGestorConviva) {
          <button
            type="button"
            class="btn_outline"
            [disabled]="!candidatos.length"
            (click)="abrirModalCorrecao()">
            Aplicar correção
          </button>
        }
      </div>
    </form>
  </div>
</section>

@if (pesquisou && resumo) {
<section class="section-resumo">
  <div class="container">
    <div class="resumo-cards">
      <div class="card-resumo">
        <span>Total</span>
        <strong>{{ resumo.totalAtividades }}</strong>
      </div>
      <div class="card-resumo">
        <span>Validados</span>
        <strong>{{ resumo.atuaisValidados }}</strong>
      </div>
      <div class="card-resumo">
        <span>Não validados</span>
        <strong>{{ resumo.atuaisNaoValidados }}</strong>
      </div>
      <div class="card-resumo destaque">
        <span>Candidatos à correção</span>
        <strong>{{ resumo.logValidadoMasAtualNao }}</strong>
      </div>
      <div class="card-resumo">
        <span>Sem log</span>
        <strong>{{ resumo.semLogEAtualNaoValidado }}</strong>
      </div>
    </div>
  </div>
</section>
}

<section class="conteudo-principal">
  <div class="container-conviva form-registro container-grid">
    <app-tabulator-table
      [columnNames]="colunasGrid"
      [tipoRelatorio]="2"
      [tableData]="candidatos"
      [height]="'420px'"
      [mostrarFiltro]="false"
      [mostrarImprimir]="false"
      [mostrarExportarHtml]="false"
      [mostrarExportarExcel]="true"
      [mostrarExportarPDF]="false"
      [orientacaoPortrait]="false">
    </app-tabulator-table>
  </div>
</section>

<app-modal *ngIf="showModalCorrecao">
  <div class="container-conviva form-registro modal-envolvidos">
    <h3 style="margin-bottom: 1rem;">Confirmar correção</h3>
    <p>
      Serão restaurados <b>{{ candidatos.length }}</b> registro(s) com status atual
      Não Validado que possuem histórico de avaliação Validado, conforme os filtros da pesquisa.
    </p>
    <p style="margin-top: 0.75rem;">
      A operação registra auditoria e aplica apenas ao período e à URE selecionados.
    </p>
    <div class="container-btns" style="justify-content: center; gap: 15px; margin-top: 20px;">
      <button type="button" class="btn_primary" (click)="confirmarCorrecao()">Confirmar</button>
      <button type="button" class="btn_outline" (click)="fecharModalCorrecao()">Cancelar</button>
    </div>
  </div>
</app-modal>
